enum BusinessType {
	COMPANY = "COMPANY",
	INDIVIDUAL = "INDIVIDUAL"
}

enum ProductType {
	FIBRE = "FIBRE",
	VOIP = "VOIP",
	MOBILE = "MOBILE",
	TV = "TV",
	EBOOK = "EBOOK",
	VOIP_CLOUDPBX = "VOIP_CLOUDPBX",
	VOIP_SIPTRUNK = "VOIP_SIPTRUNK",
	DIGITAL_SERVICES = "DIGITAL_SERVICES"
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ProductTypeToIconType: Record<ProductType, string> = {
	[ProductType.FIBRE]: "$router",
	[ProductType.VOIP]: "$telephone",
	[ProductType.MOBILE]: "$mobile",
	[ProductType.TV]: "$tv",
	[ProductType.EBOOK]: "$eBook",
	[ProductType.VOIP_CLOUDPBX]: "$voipCloud",
	[ProductType.VOIP_SIPTRUNK]: "$voipCloud",
	[ProductType.DIGITAL_SERVICES]: "$digitalService"
} as const;

enum ServiceSpecificationType {
	ADDRESS = "ADDRESS",
	SELECT = "SELECT",
	STRING = "STRING",
	NONE = "NONE"
}

enum ServiceSpecificationGroupType {
	PORTIN = "PORTIN",
	UNKNOW = "UNKNOW"
}

enum ServiceSpecificationPortinCustomerIdType {
	PORTIN_CIF = "PORTIN_CIF",
	PORTIN_DNI = "PORTIN_DNI",
	PORTIN_NIE = "PORTIN_NIE",
	PORTIN_PASSPORT = "PORTIN_PASSPORT"
}

enum ServiceSpecificationFieldType {
	ADDITIONAL_PHONE_NUMBERS = "ADDITIONAL_PHONE_NUMBERS",
	ICCID = "ICCID",
	LATITUDE = "LATITUDE",
	LONGITUDE_V2 = "LONGITUDE_V2",
	NOTES_FOR_INSTALLER = "NOTES_FOR_INSTALLER",
	PHONE_NUMBER = "PHONE_NUMBER",
	PORTIN_CONTRACT_TYPE = "PORTIN_CONTRACT_TYPE",
	PORTIN_CUSTOMER_ID_TYPE = "PORTIN_CUSTOMER_ID_TYPE",
	PORTIN_CUSTOMER_IDENTIFIER = "PORTIN_CUSTOMER_IDENTIFIER",
	PORTIN_CUSTOMER_LAST_NAME = "PORTIN_CUSTOMER_LAST_NAME",
	PORTIN_CUSTOMER_NAME = "PORTIN_CUSTOMER_NAME",
	PORTIN_ICC = "PORTIN_ICC",
	PORTIN_NUMBER = "PORTIN_NUMBER",
	PORTIN_OPERATOR = "PORTIN_OPERATOR",
	PORTIN_OPERATOR_WE_PORTIN_FROM = "Operator we Port-In from",
	PORTIN_PASSPORT_COUNTRY = "PORTIN_PASSPORT_COUNTRY",
	VOIP_CLOUDPBX_SID = "VOIP_CLOUDPBX_SID",
	VOIP_SIPTRUNK_SID = "VOIP_SIPTRUNK_SID"
}

enum ProductChangeOfAddressProcessStatus {
	FRESH = "fresh",
	ADDRESS_SEARCH = "address-search",
	ADDRESS_SELECTED = "address-selected",
	APARTMENT_SELECTED = "apartment-selected",
	INTERMEDIATE_SHOPPING_CART_CONFIGURED = "intermediate-shopping-cart-configured",
	INTERMEDIATE_SHOPPING_CART_SAVED = "intermediate-shopping-cart-saved",
	INTERMEDIATE_ORDER_DATA_SAVED = "intermediate-order-data-saved",
	FRESH_2ND_PHASE = "fresh-2nd-phase",
	FEATURES_SELECTED = "features-selected",
	SHOPPING_CART_SAVED = "shopping-cart-saved",
	SHOPPING_CART_CONFIGURED = "shopping-cart-configured",
	ORDER_DATA_SAVED = "order-data-saved",
	STOPPED = "stopped"
}

enum ProductTransitionProcessStatus {
	READY_TO_GROUP = "ready-to-group",
	GROUPED = "grouped",
	FRESH = "fresh",
	TRANSITION_SELECTED = "transition-selected",
	FEATURES_SELECTED = "features-selected",
	SHOPPING_CART_CONFIGURED = "shopping-cart-configured",
	SHOPPING_CART_SAVED = "shopping-cart-saved",
	ORDER_DATA_SAVED = "order-data-saved"
}

enum ProductModificationProcessStatus {
	READY_TO_GROUP = "ready-to-group",
	GROUPED = "grouped",
	FRESH = "fresh",
	MODIFICATION_SELECTED = "modification-selected",
	FEATURES_SELECTED = "features-selected",
	SHOPPING_CART_CONFIGURED = "shopping-cart-configured",
	SHOPPING_CART_SAVED = "shopping-cart-saved",
	ORDER_DATA_SAVED = "order-data-saved"
}

enum CustomerNewExtrasProcessStatus {
	READY_TO_GROUP = "ready-to-group",
	GROUPED = "grouped",
	FRESH = "fresh",
	EXTRAS_SELECTED = "extras-selected",
	FEATURES_SELECTED = "features-selected",
	SHOPPING_CART_CONFIGURED = "shopping-cart-configured",
	SHOPPING_CART_SAVED = "shopping-cart-saved",
	ORDER_DATA_SAVED = "order-data-saved"
}

enum ExistingCustomerBehaviourType {
	PATCH = "PATCH",
	CREATE = "CREATE"
}

enum SearchType {
	ZIP = "ZIP",
	ID = "ID",
	GOOGLE = "GOOGLE",
	COORDS = "COORDS"
}

enum GeneralDialogMode {
	ERROR = "ERROR",
	FORM_ERROR = "FORM_ERROR",
	WARNING = "WARNING",
	SUCCESS = "SUCCESS"
}

enum DateFormatType {
	LONG_DATE_TIME = "DD-MM-YYYY HH:mm:ss",
	LONG_DATE_TIME_ISO = "YYYY-MM-DD HH:mm:ss",
	SHORT_DATE_TIME = "DD-MM-YYYY",
	SHORT_TIME = "HH:mm:ss",
	DATEPICKER_LONG_DATE = "YYYY-MM-DD",
	DATEPICKER_MONTH_DATE = "YYYY-MM"
}

enum StatesFormType {
	CREATE = "CREATE",
	EDIT = "EDIT",
	SHOW = "SHOW"
}

enum TableHeaderType {
	DATE = "DATE",
	ACTIONS = "ACTIONS",
	BOOLEAN = "BOOLEAN",
	CHECKBOX = "CHECKBOX"
}

enum CustomerHandoverProcessStatusType {
	FRESH = "fresh",
	ACTIVE_CUSTOMER_FOUND = "active-customer-found",
	CREDIT_BUREAU_VALIDATION_ERROR = "credit-bureau-validation-error",
	CREDIT_BUREAU_VALIDATION_OK = "credit-bureau-validation-ok",
	IBAN_VALIDATION_OK = "iban-validation-ok",
	IBAN_VALIDATION_WARNING = "iban-validation-warning",
	CUSTOMER_ACCOUNT_ADDITIONAL_CONTACTS_HANDLED = "customer-account-additional-contacts-handled",
	CUSTOMER_ACCOUNT_CREATED = "customer-account-created",
	CUSTOMER_ACCOUNT_DOCUMENTS_HANDLED = "customer-account-documents-handled",
	CUSTOMER_ACCOUNT_ERROR = "customer-account-error",
	CUSTOMER_ACCOUNT_NOTES_CREATED = "customer-account-notes-created",
	CUSTOMER_ACCOUNT_NOTES_ERROR = "customer-account-notes-error",
	BILLING_ACCOUNT_CREATED = "billing-account-created",
	BILLING_ACCOUNT_ERROR = "billing-account-error",
	PAYMENT_METHOD_CREATED = "payment-method-created",
	PAYMENT_METHOD_ERROR = "payment-method-error",
	INCOMPATIBLE_PRODUCTS_HANDLED = "incompatible-products-handled",
	INCOMPATIBLE_PRODUCTS_ERROR = "incompatible-products-error",
	HANDLE_STEPS_ERROR = "handle-steps-error",
	TRANSITION_DELETE_STEP = "transition-delete-step",
	TRANSITION_DELETE_STEP_ERROR = "transition-delete-step-error",
	TRANSFER_STEP = "transfer-step",
	TRANSFER_STEP_ERROR = "transfer-step-error",
	TRANSITION_ADD_STEP = "transition-add-step",
	TRANSITION_ADD_STEP_ERROR = "transition-add-step-error",
	CUSTOMER_ACCOUNT_TASKS_CREATED = "customer-account-tasks-created",
	CUSTOMER_ACCOUNT_TASKS_ERROR = "customer-account-tasks-error",
	COMPLETED = "completed"
}

export {
	BusinessType,
	ExistingCustomerBehaviourType,
	CustomerHandoverProcessStatusType,
	CustomerNewExtrasProcessStatus,
	DateFormatType,
	GeneralDialogMode,
	ProductChangeOfAddressProcessStatus,
	ProductTypeToIconType,
	ProductModificationProcessStatus,
	ProductTransitionProcessStatus,
	ProductType,
	SearchType,
	ServiceSpecificationFieldType,
	ServiceSpecificationGroupType,
	ServiceSpecificationPortinCustomerIdType,
	ServiceSpecificationType,
	StatesFormType,
	TableHeaderType
};
